module.exports = __webpack_public_path__ + "img/web.25ec2570.svg";